module.exports = __webpack_public_path__ + "img/orbit-icon.219c14f6.svg";